// CORE (da inserire nel bundle principale)
import _scrollTo from "./_core/_scrollto.controls.ts";
_scrollTo.init();

import _animations from "./_engine/_animations.controls.ts";
_animations.init(undefined);

// FORMS
const forms = document.getElementsByTagName("form");
if (forms && forms.length > 0) {
    import("./_formValidation/_validation.bootstrapper.ts").then(({ default: _validationBootstrapper }) => {
        _validationBootstrapper.init(forms);
    });
    import("./_core/_floatLabels.ts").then(({ default: _floatLabels }) => {
        _floatLabels.init(document.querySelectorAll(".float-label"));
    });
}

// LIBRARIES
const swiper = document.querySelector(".swiper");
if (swiper) {
    import("./_engine/_swiper.controls.ts").then(({ default: _swiperControls }) => {
        _swiperControls.init();
    });
}

const lightbox = document.querySelector("[data-fslightbox]");
if (lightbox) {
    // @ts-ignore
    import("fslightbox");
}

// BLOCKS
const accordions = document.querySelectorAll(".accordion-container");
if (accordions && accordions.length > 0) {
    import("./_blocks/_accordion.ts").then(({ default: _accordion }) => {
        _accordion.init(accordions);
    });
}
const puntoElencoPersonalizzato = document.querySelectorAll(".punto-elenco-personalizzato");
if (puntoElencoPersonalizzato && puntoElencoPersonalizzato.length > 0) {
    import("./_blocks/_puntoElencoPersonalizzato.ts").then(({ default: _puntoElencoPersonalizzato }) => {
        _puntoElencoPersonalizzato.init(puntoElencoPersonalizzato);
    });
}

// VARIE ED EVENTUALI

// Da attivare solo nel caso in cui nel sito sono presenti fasce
// che usano il pin dello scroll-trigger, assieme a fasce che cambiano di dimensione
const needsResizeChecker = false;
if (needsResizeChecker) {
    import("./_core/_resizeChecker.ts").then(({ default: _resizeChecker }) => {
        _resizeChecker.init();
    });
}

// MENU CONTROLS

// const menuBarDesktop = document.querySelector<HTMLElement>(".menu.desktop .menu-bar");
// const menuContentDesktop = document.querySelector<HTMLElement>(".menu.desktop .menu-content");
// const menuButtonDesktop = menuBarDesktop?.querySelector<HTMLElement>(".hamburger");
// if (menuBarDesktop && menuContentDesktop && menuButtonDesktop) {
//     import("./_engine/_menu.controls.ts").then(({ default: _menuControls }) => {
//         _menuControls.init(menuBarDesktop, menuContentDesktop, menuButtonDesktop);
//     });
// }
